module.exports = __webpack_public_path__ + "0ae7e53d122e0c026a8ac0c53b76fa3d.gif";